import React from 'react'
import { DefaultTheme, ThemeProvider } from 'styled-components'

import { defaultTheme } from '../../core/application/theme/theme'
import GlobalStyle from '../layout/GlobalStyle'
import { useConfigurationContext } from '../../core/application/contexts'

export interface IThemeManagerProps {
  children?: React.ReactNode
}


const ThemeManager: React.FC<IThemeManagerProps> = ({ children }) => {

  const { tenantConfiguration } = useConfigurationContext()

  const updatedTheme: DefaultTheme = {
    ...defaultTheme,
    color: {
      ...defaultTheme.color,
      primary: tenantConfiguration?.primaryColor || defaultTheme.color.primary,
      secondary: tenantConfiguration?.fontColor === 'white' ? '#FFFFFF' : '#1E1E1E'
    }
  }

  return (
    <ThemeProvider theme={updatedTheme}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}

export default ThemeManager
